import React, { forwardRef } from 'react'

import clsx from 'clsx'

import { BaseButton } from 'components/Button'

import classes from './Tag.module.scss'

/** @type {import("./types").default} */
const Tag = forwardRef(
  (
    { avatar, children, className, color = 'teal', disableRipple = true, href, onClick, size = 'medium', ...props },
    ref
  ) => {
    return (
      <BaseButton
        ref={ref}
        className={clsx(
          'Tag',
          classes.root,
          classes[size],
          classes[color],
          { [classes.hasAvatar]: !!avatar },
          className
        )}
        disableRipple={disableRipple}
        href={href}
        onClick={onClick}
        type="button"
        {...props}
      >
        {avatar && <span className={classes.avatar}>{avatar}</span>}
        <span className={classes.label}>{children}</span>
      </BaseButton>
    )
  }
)

export default Tag
